const HOTEL_RATING_MAP = [
  { id: '0', name: 'Любой рейтинг', rating: '0' },
  { id: '2', name: 'Рейтинг > 3.0', rating: '3.0' },
  { id: '3', name: 'Рейтинг > 3.5', rating: '3.5' },
  { id: '4', name: 'Рейтинг > 4.0', rating: '4.0' },
  { id: '5', name: 'Рейтинг > 4.5', rating: '4.5' },
];

export default HOTEL_RATING_MAP;
